<template>
    <div id="settingsProducttypespage">
        <div class="top-buttons">
            <ui5-button @click="back()">
                {{ trans('pages.settings_producttypes.back_to_settings') }}
            </ui5-button>
            <ui5-button @click="add()">
                {{ trans('pages.settings_producttypes.add_product_type') }}
            </ui5-button>
        </div>
        <div>
            <h2>
                {{ trans('pages.settings_producttypes.active_product_types') }}
            </h2>
            <product-type-overview-table
                :suppliers="suppliers"
                :product-type-groups="productTypeGroups"
                :product-types="activeProductTypes"
            />

            <h2>
                {{
                    trans('pages.settings_producttypes.inactive_product_types')
                }}
            </h2>
            <product-type-overview-table
                :suppliers="suppliers"
                :product-type-groups="productTypeGroups"
                :product-types="inactiveProductTypes"
            />
        </div>
    </div>
</template>
<script>
import ProductTypeOverviewTable from './../components/productTypes/ProductTypeOverviewTable';
import productTypeApi from '../api/productType';
import productTypeGroupApi from '../api/productTypeGroup';
import supplierApi from '../api/supplier';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            productTypeGroups: null,
            suppliers: null,
            activeProductTypes: null,
            inactiveProductTypes: null,
        };
    },
    methods: {
        back() {
            this.$router.push('/settings');
        },
        add() {
            this.$router.push('/addProductType');
        },
    },
    mounted() {
        productTypeGroupApi.list().then((response) => {
            this.productTypeGroups = response.data;
        });

        supplierApi.fetchAllSuppliers().then((response) => {
            this.suppliers = response.data.data;
        });

        productTypeApi
            .getProductTypes(
                productTypeApi.PRODUCTTYPE_ONLY_ACTIVE,
                false,
                false
            )
            .then((response) => {
                this.activeProductTypes = response.data.data;
            });

        productTypeApi
            .getProductTypes(
                productTypeApi.PRODUCTTYPE_ONLY_INACTIVE,
                false,
                false
            )
            .then((response) => {
                this.inactiveProductTypes = response.data.data;
            });
    },
    components: {
        'product-type-overview-table': ProductTypeOverviewTable,
    },
};
</script>
